<script>
	import router from "../../stores/router";
	import base from "../../stores/base";

	import UIShare from "../UIShare.svelte";
</script>

<footer class="Footer">
	<div class="Footer-logo">
		<a href="/"><img src="/img/footer-logo.png" alt="ずっとびロゴ" /></a>
	</div>
	<nav class="Footer-nav">
		{#each $base.menu as { url, label }}
			<a href={url} on:click|preventDefault={() => router.push(url)}
				>{@html label[$base.lang].split("\n").join("<br>")}</a
			>
		{/each}
	</nav>
	<nav class="Footer-sub">
		{#each $base.submenu as { url, label }}
			<a href={url} on:click|preventDefault={() => router.push(url)}
				>{@html label[$base.lang].split("\n").join("<br>")}</a
			>
		{/each}
	</nav>
	<UIShare />
	<nav class="Footer-banners">
		{#each $base.banners as { url, label, image }}
			<a href={url} on:click|preventDefault={() => router.push(url)}
				><img src={image} alt={label} /></a
			>
		{/each}
	</nav>
	<p class="Footer-copyright">
		{#each $base.copyright as { label }}
			{@html label[$base.lang].split("\n").join("<br>")}
		{/each}
	</p>
</footer>

<style global>
	.Footer {
		background: #61788c;
		text-align: center;
		padding: 1em;
		color: #fff;
	}
	:global(.pc) .Footer {
		padding: 2em;
	}
	.Footer-logo {
		padding: 3em 0;
	}
	:global(.pc) .Footer-logo {
		padding: 3.5em 0;
	}
	.Footer-logo img {
		width: 60%;
		height: auto;
	}
	.pc .Footer-logo img {
		width: 282px;
	}
	.Footer-logo > a {
		border: 1px dashed transparent;
		display: inline-block;
	}
	.Footer-logo > a:focus-visible {
		border-color: #fff;
	}

	.Footer-nav {
		font-size: 1.3em;
	}
	.pc .Footer-nav {
		display: inline-block;
		padding: 0.75em 0;
		font-size: 1.25em;
	}

	.Footer-nav > a {
		display:block;
		padding: 0.75em 0;
		border-bottom: 1px dashed transparent;
		line-height: 1.3;
		background: none;
	}
	.Footer-nav > a:hover {
		text-decoration: underline;
	}

	.pc .Footer-nav > a {
		display: inline-block;
		padding: 0 2em;
		background: url(../img/h_border.png) left center no-repeat;
	}
	.Footer-nav > a:first-child {
		background: none;
	}
	.Footer-nav > a span {
		font-size: 0.8em;
	}
	.Footer-nav > a:focus-visible {
		border-color: #fff;
	}

	.Footer-sub {
		padding: 0.75em 0;
	}
	.Footer-sub > a {
		display: inline-block;
		font-size: 0.75em;
		padding: 0 1em;
		border-bottom: 1px dashed transparent;
		background: url(../img/h_border.png) left center no-repeat;
	}
	.Footer-sub > a:hover {
		text-decoration: underline;
	}
	.pc .Footer-sub > a {
		font-size: 0.75em;
	}
	.Footer-sub > a:first-child {
		background: none;
	}
	.Footer-sub > a:focus-visible {
		border-color: #fff;
	}

	.Footer-banners {
		max-width:27.3em;
		margin: 0 auto;
		padding: 1.5em 0 2em;
	}
	.pc .Footer-banners {
		padding: 1.5em 0 1em;
	}
	.Footer-banners > a {
		display: inline-block;
		margin: 0.5em;
		transition: opacity 100ms linear;
		opacity: 0.9;
		border: 1px dashed transparent;
	}
	.Footer-banners > a:hover {
		opacity: 1;
	}
	.Footer-banners > a:focus-visible {
		border-color: #fff;
	}

	.Footer-banners > a > img {
		width: 150px;
	}
	:global(.pc) .Footer-banners > a > img {
		width: 200px;
	}

	.Footer-copyright {
		padding: 1.5em 0;
		font-size: 0.7em;
	}
	.Footer-copyright > a:hover {
		text-decoration: underline;
	}
</style>
